<ng-container *ngIf="images$ | async as images; else loading">
  <div fxLayout="column" fxLayout.gt-sm="row">
    <div fxFlex.gt-sm="45">
      <app-gallery-slider [images]="images" [info]="info"></app-gallery-slider>
    </div>

    <section
      fxFlex.gt-sm="55"
      class="content"
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      <ul>
        <li *ngFor="let category of categories">
          <a [routerLink]="[category]">
            <h2 class="h3" data-cursor="cursor-link">{{ category }}</h2>
          </a>
        </li>
      </ul>
    </section>
  </div>
</ng-container>

<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
